import { PlaceOfOccurrenceEnum } from "./enums/PlaceOfOccurrenceEnum";

type PlaceOfOccurrenceEnumKey = keyof typeof PlaceOfOccurrenceEnum;

type PlaceOfOccurrenceKeyValue = {
	[key in PlaceOfOccurrenceEnumKey]: string;
};

export const placesOfOccurrence: PlaceOfOccurrenceKeyValue = {
	HOME: "Domicílio",
	HOSPITAL: "Hospital",
	IGNORED: "Ignorado",
	OTHER_HEALTH_ESTABLISHMENT: "Outro estabelecimento de saúde",
	OTHERS: "Outros",
	PUBLIC_ROAD: "Via pública",
};

export function getPlaceOfOccurrence(value: PlaceOfOccurrenceEnum) {
	const enumKey = Object.keys(PlaceOfOccurrenceEnum).find(
		(key) => PlaceOfOccurrenceEnum[key as keyof typeof PlaceOfOccurrenceEnum] === value
	);

	if (enumKey) {
		return placesOfOccurrence[enumKey as keyof PlaceOfOccurrenceKeyValue];
	}
	return undefined; // Caso não encontre um valor correspondente
}
